// src/lib/echo.js

import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

let echo = null;
let echoToken = null;

export function getEcho() {
  const token = localStorage.getItem("token");

const appKey = process.env.REACT_APP_REVERB_APP_KEY || "zczgjpji2dp1qlkunvqv";
  const host = process.env.REACT_APP_REVERB_HOST || "dev.expertise.gov.kz";
  const scheme = process.env.REACT_APP_REVERB_SCHEME || "https";
  const port = Number(process.env.REACT_APP_REVERB_PORT || (scheme === "https" ? 443 : 8080));

  const apiBaseUrl =
    process.env.REACT_APP_API_BASE_URL || "https://expertise.gov.kz";

  if (!token || !appKey || !host) {
    console.warn("Echo config missing", { hasToken: Boolean(token), appKey, host });
    return null;
  }

  if (echo && echoToken !== token) {
    echo.disconnect();
    echo = null;
  }

  if (echo) return echo;

  echoToken = token;



  echo = new Echo({
  broadcaster: "reverb",
  key: appKey,
  wsHost: host,
  wsPort: port,
  wssPort: port,
  forceTLS: scheme === "https",
  encrypted: scheme === "https",
  enabledTransports: ["ws"],
  cluster: "",
  disableStats: true,
  authEndpoint: `${apiBaseUrl}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  },
});

window.Echo = echo; // ← для X-Socket-ID в interceptor

return echo;


// Принудительно подключаемся
echo.connector.pusher.connect();

window.Echo = echo;
  return echo;
}

export function disconnectEcho() {
  if (echo) {
    echo.disconnect();
    echo = null;
    echoToken = null;
  }
}